export const RRP_POPSTATION_LIMIT = 3;
export const RRP_INSTALLMENT_PLANT =
  'https://www.singtel.com/content/dam/singtel/eshop/Agreements/accessories-ipp-tncs.pdf';
export const RRP_MAX_CART_ITEMS = 10;
export const RRP_MAX_CART_VALUE = 10000;
export const RRP_SELLING_FAST_THRESHOLD = 2;
export const RRP_FALLBACK_URL = `${process.env.GATSBY_AEM_URL}/personal/products-services/mobile/accessories/other-brands`;
